import { useState } from "react";

import "./nav-list-component-styles.scss";

import NavItemComponent from "../../components/nav-item-component/nav-item-component";

const NavListComponent = () => {
	const [activeItem, setActiveItem] = useState("Home");

	const navDetails = [
		{
			item: "Home",
			itemLink: "https://moazamdev.vercel.app",
		},
		{
			item: "About",
			itemLink: "/#about-section",
		},
		{
			item: "Projects",
			itemLink: "/#work-section",
		},
		{
			item: "Articles",
			itemLink: "/#articles-section",
		},
		{
			item: "Contact",
			itemLink: "/#contact-section",
		},
	];

	return (
		<div className="nav-items-box">
			<ul className="nav-items">
				{navDetails.map((navItem) => {
					return (
						<NavItemComponent
							activeItem={activeItem}
							setActiveItem={setActiveItem}
							key={navItem.item}
							item={navItem.item}
							itemLink={navItem.itemLink}
						/>
					);
				})}
			</ul>
		</div>
	);
};

export default NavListComponent;
